import { Setting } from './setting.model';
import { PageSection } from './page-section.model';
import { HeroTallContent } from './hero-tall-content.model';

export class PageContent {
  uid?: string;
  hero?: HeroTallContent | null;
  items: PageSection[] = [];
  settings?: Setting[];
}
